import { sendAnalytics } from 'shared/utils/analytics';

export const trackAllOffersLinkClick = (count: number) =>
  sendAnalytics({
    action: 'Click',
    label: `house_offers_more/${count}`,
  });
